import { Organization } from '../component/common-components/organizations/model/organization.model';

export class Region {
    ID!: number;
    ORGANIZATIONS_ID: number;
    CODE!: string;
    NAME?: string;
    CREATED_BY?: string;
    CREATED_DATE?: Date;
    MODIFIED_BY?: string;
    MODIFIED_DATE?: Date;

    ORGANIZATION?: Organization;
	NODE_REGIONS?: any[] | undefined;
	TRANSITION_REGIONS: any[] | undefined;
    SURVEY_REGIONS: any[] | undefined;
}

export function compareRegion(r1: Region, r2: Region) {
    const compare = parseInt(r2.CODE!) - parseInt(r1.CODE!);

    if (compare < 0) {
        return 1;
    } else if (compare > 0) {
        return -1;
    } else return 0;
}

export interface PARTYROLETYPES {
    ID: number;
    TYPE: string;
    DESCRIPTION: string;
    CREATED_BY?: any;
    CREATED_DATE: Date;
    MODIFIED_BY?: any;
    MODIFIED_DATE?: any;
    PARTY_CONTACT_MECHANISMS: any[];
    PARTY_ROLES: any[];
    PARTY_SERVICES: any[];
    ELIGIBLE_TO_PROVIDE: any[];
    PARTY_ROLE_CATEGORIES: any[];
    PARTY_ROLE_PROJECT_TYPE: any[];
}

export interface PARTYROLE {
    ID: number;
    PARTIES_ID: number;
    PARTY_ROLE_TYPES_ID: number;
    CREATED_BY?: any;
    CREATED_DATE: Date;
    MODIFIED_BY?: any;
    MODIFIED_DATE?: any;
    ELIGIBILITies: any[];
    PARTy?: any;
    PARTY_PRE_SCREENS: any[];
    PARTY_RELATIONSHIPS: any[];
    PARTY_RELATIONSHIPS1: any[];
    PARTY_ROLE_ACCOUNT_REQUESTS: any[];
    PARTY_PROJECTS: any[];
    PARTY_ROLE_TYPES: PARTYROLETYPES;
    SERVICE_PROVIDERS: any[];
    SURVEY_ANSWER: any[];
}

export interface PARTy {
    ID: number;
    CREATED_BY?: any;
    CREATED_DATE: Date;
    MODIFIED_BY?: any;
    MODIFIED_DATE?: any;
    COMMUNICATION_EVENT_ROLES: any[];
    FACILITY_ROLES: any[];
    ORGANIZATIONS: any[];
    PARTY_PROGRAMS: any[];
    SERVICE_ITEMS: any[];
    PARTY_CONTACT_MECHANISMS: any[];
    PARTY_ROLES: PARTYROLE[];
    PARTY_STATUSES: any[];
    PARTY_WORK_EFFORT: any[];
    PERSONS: any[];
    REQUIREMENT_ROLES: any[];
    PROVISIONAL_SCHOOLS: any[];
}

export interface ORGANIZATION {
    ID: number;
    PARTIES_ID: number;
    NAME: string;
    CREATED_BY?: any;
    CREATED_DATE: Date;
    MODIFIED_BY?: any;
    MODIFIED_DATE?: any;
    SCHOOL_DISTRICTS_ID?: any;
    EMAIL_DOMAIN?: any;
    DEPARTURE_DATES: any[];
    EMAIL_DOMAINS: any[];
    LEGAL_ORGANIZATIONS: any[];
    MSIN_SCHOOLS: any[];
    REGIONS: any[];
    SCHOOL_DISTRICTS: any[];
    STUDENT_IDENTIFIER_ORGANIZATIONS: any[];
    PARTy: PARTy;
    SCHOOLS: any[];
}
